import { useState } from 'react'

import PropTypes from 'prop-types'
import {
  Container,
  ContentHeader,
  Page,
  MenuButton,
  LoadingFeedback,
} from 'components'

import { ActionButtons, OrganizationForm } from './components'

import { useFetch, usePermissions } from 'hooks'

import constants from 'constants/index'
import * as service from 'service'

const OrganizationsEdit = ({ match }) => {
  const [isActionLoading, setIsActionLoading] = useState(false)

  const permissions = usePermissions()

  const { organizationId } = match.params

  const { response, isLoading, refresh } = useFetch(
    service.backoffice.organizations.get,
    { organizationId },
  )

  const editionPermitted = permissions.permitted(
    constants.permissions.ORGANIZATION.MANAGE,
  )

  const organization = response?.data?.organization

  return (
    <Page title="Atualizar Grupo Advisor">
      <LoadingFeedback open={isLoading || isActionLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          menu="Grupos Advisor"
          title="Alterar Grupo Advisor"
          subtitle="Atualizar os dados do Grupo Advisor"
        >
          <MenuButton>
            <ActionButtons
              organization={organization}
              refresh={refresh}
              setIsLoading={setIsActionLoading}
            />
          </MenuButton>
        </ContentHeader>
        <OrganizationForm
          organization={organization}
          editionMode
          editionPermitted={editionPermitted}
          refresh={refresh}
          isOrganizationLoading={isLoading}
        />
      </Container>
    </Page>
  )
}

OrganizationsEdit.propTypes = {
  match: PropTypes.object,
}

export default OrganizationsEdit
